export const NotStarted = 'Not Started';
export const UploadInProgress = 'Upload In Progress';
export const Submitted = 'Submitted';
export const ReviewInProgress = 'Review In Progress';
export const Complete = 'Complete';


// WEBPACK FOOTER //
// ./src/modules/record/record.status.js